import type {
  MarkApplicationsReadMutation,
  MarkApplicationsReadMutationVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import type { PageConfig } from 'src/libs/PageConfig';

import hirerGraphqlClient from './client';
import { mutation } from './schema/mutationMarkApplicationsRead';

export const markApplicationsRead = async (
  prospectIds: string[],
  addCustomError: PageConfig['dataDogRum']['addCustomError'],
) => {
  if (prospectIds.length === 0) {
    return true;
  }
  try {
    const { data } = await hirerGraphqlClient.mutate<
      MarkApplicationsReadMutation,
      MarkApplicationsReadMutationVariables
    >({
      variables: { input: { prospectIds } },
      mutation,
    });
    return data?.markApplicationsRead.success ?? false;
  } catch (error) {
    addCustomError({
      error,
      context: {
        activity: 'MARK_APPLICATIONS_READ',
        description: 'Error marking applications as read',
        prospectIds,
      },
    });
    return false;
  }
};
